// @flow
import { connect } from 'react-redux';
import Details from './Details';
import { canDeleteABonusSelector } from '../../../../../../modules/SignUp/Bonus';

const mapStateToProps = state => ({
  canBeDeleted: canDeleteABonusSelector(state),
});

export default connect(mapStateToProps)(Details);
